var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCreditcardDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21.3px",
    height: "16.9666667px",
    viewBox: "0 0 21.3 16.9666667",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 14") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDDA5\\uFE0F-Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gestionnaire---Paiements---Volets-ferm\\xE9s",
    transform: "translate(-65.350000, -483.516667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(63.000000, 479.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 26 0 26 26 0 26"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#030303",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x: 3.25,
    y: 5.41666667,
    width: 19.5,
    height: 15.1666667,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.25,
    y1: 10.8333333,
    x2: 22.75,
    y2: 10.8333333,
    id: "Path",
    stroke: "#030303",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.58333333,
    y1: 16.25,
    x2: 7.59416667,
    y2: 16.25,
    id: "Path",
    stroke: "#030303",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.9166667,
    y1: 16.25,
    x2: 14.0833333,
    y2: 16.25,
    id: "Path",
    stroke: "#030303",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCreditcardDark);
export default __webpack_public_path__ + "static/media/icon_creditcard_dark.ebbb71a7cb1fd6217302b81b9c61752c.svg";
export { ForwardRef as ReactComponent };